module.exports = __webpack_public_path__ + "static/media/treant.a8bb8fec.png";